import HubspotAndLogosFormComponent from "./hubspot-and-logos-form-component";
import HubspotAndLogosFormConfig from "./hubspot-and-logos-form-config";
import HubspotAndLogosFormAdvancedConfig from "./hubspot-and-logos-form-advanced-config";

export default {
  HubspotAndLogosFormComponent,
  HubspotAndLogosFormConfig,
  HubspotAndLogosFormAdvancedConfig
};
